import { createAction, props } from "@ngrx/store";
import { FuelingModeDTO } from "src/app/models/fueling-mode/fueling-modeDTO";

export const resetFuelingModesState = createAction(
  "[FuelingMode] Reset Fueling Modes State Action"
);
export const resetFuelingMode = createAction(
  "[FuelingMode] Reset Fueling Mode State Action"
);
export const getFuelingModes = createAction(
  "[FuelingMode] Get All Fueling Modes Action",
  props<{ options: any }>()
);
export const loadFuelingModes = createAction(
  "[FuelingMode] Load All Fueling Modes Action",
  props<{ response: any[] }>()
);
export const getFuelingModesExcel = createAction(
  "[FuelingMode] Get All Fueling Modes Excel Action",
  props<{ options: any }>()
);
export const loadFuelingModesExcel = createAction(
  "[FuelingMode] Load All Fueling Modes Excel Action",
  props<{ response: any[] }>()
);
// Deliveries Table Configuration Settings
export const getFuelingModesTableConfig = createAction(
  "[FuelingMode] Get Fueling Modes Table Configuration Action",
  props<{ options: any }>()
);
export const loadFuelingModesTableConfig = createAction(
  "[FuelingMode] Load Fueling Modes Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveFuelingModesTableConfig = createAction(
  "[FuelingMode] Save Fueling Modes Table Configuration Action",
  props<{ config: any }>()
);
export const updateFuelingModes = createAction(
  "[FuelingMode] Update Fueling Modes Action",
  props<{ fuelingMode: FuelingModeDTO }>()
);
export const getFuelingMode = createAction(
  "[FuelingMode] Get Fueling Mode Action",
  props<{ code: string }>()
);
export const loadFuelingMode = createAction(
  "[FuelingMode] Load Fueling Mode Action",
  props<{ response: any }>()
);
export const createFuelingMode = createAction(
  "[FuelingMode] Create Fueling Mode Action",
  props<{ fuelingMode: FuelingModeDTO }>()
);
export const loadFuelingModesLoadStart = createAction(
  "[FuelingMode] Load Fueling Mode Start Action"
);
export const loadFuelingModesLoadEnd = createAction(
  "[FuelingMode] Load Fueling Mode End Action"
);

export const resetCreation = createAction(
  "[FuelingMode] Reset Creation Action"
);
